'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'LIST',
	name: 'List',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['CELL_01'],
	category: 'Text',
	props: [{
		name: 'orientation',
		inputType: 'select',
		label: 'Orientation',
		default: 'vertical',
		values: ['vertical', 'horizontal']
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
		label: 'List bullet',
		props: [{
			name: 'bullet',
			inputType: 'select',
			label: 'bullet',
			default: 'none',
			values: ['none', 'disc', 'circle', 'square', 'decimal', 'decimal-leading-zero', 'lower-alpha', 'upper-alpha', 'lower-roman', 'upper-roman']
		}, {
			name: 'image',
			inputType: 'media',
			label: 'Image',
			default: ''
		}, {
			name: 'bulletPosition',
			inputType: 'select',
			label: 'Bullet Position',
			default: 'initial',
			values: ['initial', 'inside', 'outside']
		}]
	})
};